var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGif = function SvgGif(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.027 29H11.973C11.7149 29 11.4674 28.8975 11.285 28.715C11.1025 28.5326 11 28.2851 11 28.027V11.973C11 11.7149 11.1025 11.4674 11.285 11.285C11.4674 11.1025 11.7149 11 11.973 11H28.027C28.2851 11 28.5326 11.1025 28.715 11.285C28.8975 11.4674 29 11.7149 29 11.973V28.027C29 28.2851 28.8975 28.5326 28.715 28.715C28.5326 28.8975 28.2851 29 28.027 29Z",
    stroke: "#5A6367",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5446 19.0452C18.5476 18.7475 18.4906 18.4525 18.3774 18.1781C18.2641 17.9038 18.0969 17.6561 17.8861 17.4503C17.6753 17.2444 17.4254 17.0849 17.1518 16.9814C16.8782 16.878 16.5867 16.8329 16.2953 16.8488C15.7291 16.9 15.2038 17.1709 14.8278 17.6057C14.4519 18.0405 14.254 18.606 14.275 19.1854V21.1948C14.2731 21.4822 14.327 21.7671 14.4334 22.0332C14.5398 22.2993 14.6967 22.5413 14.8951 22.7454C15.0934 22.9494 15.3294 23.1115 15.5893 23.2224C15.8492 23.3332 16.1281 23.3905 16.4098 23.3912C16.6905 23.3912 16.9685 23.3347 17.2278 23.2249C17.4871 23.1152 17.7227 22.9544 17.921 22.7517C18.1193 22.549 18.2764 22.3084 18.3835 22.0436C18.4905 21.7789 18.5452 21.4952 18.5446 21.2088H16.4098M26.1371 16.8488H22.944V23.3631M22.944 20.106H25.0193",
    stroke: "#5A6367",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5898 16.7266V23.5082",
    stroke: "#5A6367",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGif);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gif.5057df00c8bb9d79efb9ec107e1c99a1.svg";